<template>
  <div>
    <Header v-if="!totem" :home=true :totem="totem"/>
    <!-- <full-page ref="fullpage" :options="options" id="fullpage"> -->
      <!-- CONSULTA -->
      <div class="section">
        <div id="wrapper-consulta"> 
          <FormConsulta :totem="totem"/>
         </div> 
      </div>

    <ModalUploadDocumentos
        modal-id="upload-modal"
        title="Upload de Documentos"
        :accepted-types="'.pdf,.jpg,.png'"
        :max-file-size="5242880"
        :max-files="18"
        :allow-multiple="true"
        @files-selected="handleFilesSelected"
    />

      <!-- NOSSOS SERVIÇOS / CARDS -->
      <!-- <div id="servicos" class="section">
        <Cards />
      </div> -->

      <!-- CERTIDÃO -->
      <!-- <div id="certidao" class="section">
          <Certidao />
      </div> -->

      <!-- <div v-if="!dispositivo"  class="section">
          <Anuencia />
      </div> -->
      
      <!--<div id="sabia" v-if="!dispositivo"  class="section">
        <VoceSabia />
      </div>-->

      <!-- CONTATO -->
      <!-- <div id="contato" class="section">
        <Contato />
      </div> -->
    <!-- </full-page> -->
      <footersite class="d-none d-xl-block" v-if="!totem" />
      <footersitemobile class="d-block d-xl-none" v-if="!totem"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import FormConsulta from '@/views/Home/FormConsulta'
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";
import ModalUploadDocumentos from "@/components/documentos/modal_upload_documentos/ModalUploadDocumentos.vue";
// import Cards from '@/views/Home/Cards'
// import Certidao from '@/views/Home/Certidao'
// import Anuencia from '@/views/Home/Anuencia'
// import Contato from '@/views/Home/Contato'
//import VoceSabia from '@/views/Home/VoceSabia'

const scrollingSpeed = 1500

const titulos = [
  'CENPROT Nacional',
  'Nossos serviços',
  'Cartórios na mídia',
  'Vantagens do Protesto',
  'Faça um convênio',
  'Fale conosco'
]

export default {
  name: "home",
  components: {
    ModalUploadDocumentos,
    Header,
    FormConsulta,
    footersite,
    footersitemobile,
    // Cards,
    // Certidao,
    // Anuencia,
    // Contato,
    //VoceSabia
  },
  data() {
    return {
      interval:5,
      dispositivo: window.matchMedia("(orientation: portrait)").matches,
      totem:0,
      options: {
        licenseKey: "",
        menu: "#menu",
        scrollingSpeed: scrollingSpeed,
        normalScrollElements: '',
        fitToSection: false,
        scrollBar: true,
        /*lockAnchors: false,
        anchors:['home', 'servicos', 'certidao', 'anuencia', 'cancelamento', 'contato'],*/
        afterLoad: function(origin, destination) {
          // atualiza título da página
          document.title = titulos[destination.index];
        },
        onLeave(origin, destination) {
          // cor do cabeçalho
          let header = document.getElementById('cabecalho')
          if(destination.index == 0)
            header.classList.remove('azul')
          else
            header.classList.add('azul')
        },
        }
    }
  },
  methods: {
    handleFilesSelected(data) {
      console.log('Selected files:', data.files)
      console.log('FormData ready:', data.formData)

      this.$bvModal.hide('upload-modal')
    }
  },
  mounted() {
    // vindo para redefinir senha...
    if(this.$route.meta.totem != null)this.totem = this.$route.meta.totem;
    if(this.$route.query.rs) this.$router.push('recuperar-senha/'+this.$route.query.rs)
    if(this.$route.query.code) this.$root.loginGov(this.$route.query.code);
    // this.$bvModal.show('upload-modal');
  }
}
</script>

<style scoped>
/* imagens de fundo dos slides FIXAS */
div.section.fp-section {
  position: static;
  background-repeat:no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
#consulta {
  background-image: url("~@/assets/imgs/header.png");
}
#servicos {
  background-image: url("~@/assets/imgs/japones_1.png");
}

#contato {
  background: #e4ebe9 url("~@/assets/imgs/pattern.png") repeat top left;
}
#wrapper-consulta {
  /* float: right; */
  /* position: relative;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%; */
}
@media (min-width: 360px) { 
.slide-content-wrapper[data-v-d6e2d5d8] {
    padding-top: 55px;
}
}
 @media (max-width: 765px) { 
#consulta {
  width: 100%;
  height: auto;
  background-image: url("~@/assets/imgs/header-mobile.png");
  background-size: cover;
  background-attachment:scroll;
  height: 100%;
  overflow: hidden;
  top: 0; 
  left: 0; 
  min-width: 100%;
  min-height: 100%;
}
} 
@media (min-width: 1200px) and (max-width: 1600px) {
#consulta {
background-image: url("~@/assets/imgs/header.png");
}
} 
</style>
